import {FC, useState, useEffect} from 'react'
import InfoBoxTable from './InfoBoxTable'
type Props = {
  assessmentType: string
}

const InfoBoxContent: FC<Props> = ({assessmentType}) => {
  const [open, setOpen] = useState(true)

  return (
    <>
      <div
        className='px-5 py-3 d-flex justify-content-between align-items-center text-white fw-semibold'
        onClick={() => setOpen(!open)}
        style={{
          background: 'linear-gradient(90deg, #F95E2F 0%, #FCCDBF 100%)',
          borderRadius: '1rem',
          cursor: 'pointer',
        }}
      >
        <div className='d-flex align-items-center gap-2'>
          <div
            style={{
              backgroundColor: '#fc5c2e', // oranye terang
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: '8px',
            }}
          >
            <div
              style={{
                backgroundColor: '#ffa78d', // oranye muda/pink muda
                borderRadius: '50%',
                width: '18px',
                height: '18px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <i className='fas fa-info' style={{color: 'white'}}></i>
            </div>
          </div>
          <p className='fw-bold'>
            Panduan pengisian setiap indikator disesuaikan dengan jenis penilaian
          </p>
        </div>

        <i
          className={`${open ? 'fas fa-chevron-up text-white' : 'fas fa-chevron-down text-white'}`}
        ></i>
      </div>

      {open ? (
        <div
          className='my-8 mx-4'
          style={{background: '#FAFAFA', border: '1px solid #E3D4D4', borderRadius: '10px'}}
        >
          <InfoBoxTable assessmentType={assessmentType} />
        </div>
      ) : null}
    </>
  )
}

const InfoBox: FC<Props> = ({assessmentType}) => {
  return <InfoBoxContent assessmentType={assessmentType} />
}

export default InfoBox
